import { render, staticRenderFns } from "./articlesHome.vue?vue&type=template&id=ac0a7c88&scoped=true&"
import script from "./articlesHome.vue?vue&type=script&lang=js&"
export * from "./articlesHome.vue?vue&type=script&lang=js&"
import style0 from "./articlesHome.vue?vue&type=style&index=0&id=ac0a7c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0a7c88",
  null
  
)

export default component.exports